import { getCookies } from "../../utils/getters/getCookies";

export const initCookie = () => {
	const cookieWrapper = document.querySelector( '.cookie-notification-bar' );
	if ( !cookieWrapper ) {
		return;
	}

	const allowBtn = cookieWrapper.querySelector( '.close' );
	const showInfoBtn = cookieWrapper.querySelector( '.show-info' );
	const InfoWrapper = cookieWrapper.querySelector( '.info' );
	const cookieName = 'cookie_policy_cdsvideo';
	
	const cookies = getCookies();

	if ( cookies[cookieName] )
	{
		cookieWrapper.remove();

		return;
	}

	showInfoBtn.addEventListener( 'click', () => {
		InfoWrapper.classList.toggle( 'hide' );
		showInfoBtn.classList.toggle( 'inactive' );
	} );
	
	cookieWrapper.classList.remove( 'not-init' );
	setTimeout( () => {
		cookieWrapper.classList.remove( 'hide' );
	}, 1000 );

	const domain = location.host;

	allowBtn.addEventListener( 'click', () => {
		if ( domain.includes( '.ru' ) )
		{
			document.cookie = `${cookieName}=read; domain=${domain}; expires=${new Date( 2999, 5, 12 ).toUTCString()}; path=/`;
		}
		else
		{
			document.cookie = `${cookieName}=read; expires=${new Date( 2999, 5, 12 ).toUTCString()}; path=/`;
		}
	
		cookieWrapper.classList.add( 'hide' );
		cookieWrapper.remove();
	} );
};
